module.exports = __webpack_public_path__ + "static/default-img-7f132e07f733650715d9cd0a69959b1a.jpg";